<template>
  <div class="row justify-content-center mr-3 ml-3">
    <div class="relative">
      <div class="vx-navbar-wrapper navbar-full p-0">
        <vs-navbar
          class="navbar-custom navbar-skelton"
          :class="navbarClasses"
          :style="navbarStyle"
          :color="navbarColor"
        >
          <router-link
            tag="div"
            to="/manage_monitoring"
            class="vx-logo cursor-pointer flex items-center"
          >
            <img src="@/assets/images/k/logo_monitoring.png" />
            <span class="vx-logo-text-large">Monitoring Dashboard</span>
          </router-link>
          <router-link
            tag="div"
            to="/manage_monitoring"
            class="vx-logo cursor-pointer mx-auto flex justify-center"
          >
          </router-link>
          <router-link
            tag="div"
            to="/manage_monitoring"
            class="vx-logo cursor-pointer flex items-center justify-end"
          >
            <img
              src="@/assets/images/k/siren.gif"
              style="width: 50px; height: 50px"
              v-if="this.itemHeader.is_alert === true"
              class="mr-12"
            />
            <img
              src="@/assets/images/k/siren.png"
              style="width: 50px; height: 50px"
              class="mr-12"
              v-else
            />
            <vx-row>
              <span class="vx-logo-text-small">Admin Koder3</span><br />
              <p>dashboard@koder3.com</p>
            </vx-row>

            <vs-avatar color="danger" text="koder3" class="ml-3" />

            <feather-icon
              icon="MenuIcon"
              title="Export Excel"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              class="ml-3"
            />
          </router-link>
        </vs-navbar>
      </div>
    </div>

    <vs-card style="">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <div
            class="vx-card__collapsible-content vs-con-loading__container"
            style="border-right: 2px solid gainsboro"
          >
            <div class="vx-row" style="">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <div slot="no-body">
                  <div class="pr-3 p-6 pb-0">
                    <div align="center">
                      <img
                        src="@/assets/images/k/gis_car.png"
                        style="width: 100px; height: 90px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-2/3">
                <div slot="no-body">
                  <div class="p-0 pb-0">
                    <div align="center"></div>
                    <div class="truncate">
                      <div class="font-header mt-4 text-warning" align="center">
                        <!-- {{
                          this.itemHeader.total_visit_count | numFormat(0, 0)
                        }} -->
                        <IOdometer
                          class="iOdometer"
                          :value="this.itemHeader.total_visit_count"
                        />
                      </div>
                      <h2 class="text-warning" align="center">
                        จำนวนรถบันทึกทั้งหมด
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <div
            class="vx-card__collapsible-content vs-con-loading__container"
            style="border-right: 2px solid gainsboro"
          >
            <div class="vx-row" style="">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <div slot="no-body">
                  <div class="pr-3 p-6 pb-0">
                    <div align="center">
                      <img
                        src="@/assets/images/k/gis_car_today.png"
                        style="width: 100px; height: 90px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-2/3">
                <div slot="no-body">
                  <div class="p-0 pb-0">
                    <div align="center"></div>
                    <div class="truncate">
                      <div class="font-header mt-4 text-success" align="center">
                        <!-- {{
                          this.itemHeader.total_visit_count_today
                            | numFormat(0, 0)
                        }} -->
                        <IOdometer
                          class="iOdometer"
                          :value="this.itemHeader.total_visit_count_today"
                        />
                      </div>
                      <h2 class="text-success" align="center">
                        จำนวนรถบันทึกวันนี้
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <div
            class="vx-card__collapsible-content vs-con-loading__container"
            style="border-right: 2px solid gainsboro"
          >
            <div class="vx-row" style="">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <div slot="no-body">
                  <div class="pr-3 p-6 pb-0">
                    <div align="center">
                      <img
                        src="@/assets/images/k/game-icons_money-stack.png"
                        style="width: 100px; height: 90px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-2/3">
                <div slot="no-body">
                  <div class="p-0 pb-0">
                    <div align="center"></div>
                    <div class="truncate">
                      <div class="font-header mt-4" align="center">
                        <!-- {{ this.itemHeader.total_visit_fee | numFormat(0, 0) }} -->
                        <IOdometer
                          class="iOdometer"
                          :value="this.itemHeader.total_visit_fee"
                        />
                      </div>
                      <h2 align="center">ยอดรวมค่าจอดทั้งหมด</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-row" style="">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3">
                <div slot="no-body">
                  <div class="pr-3 p-6 pb-0">
                    <div align="center">
                      <img
                        src="@/assets/images/k/vaadin_money-deposit.png"
                        style="width: 110px; height: 70px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-2/3">
                <div slot="no-body">
                  <div class="p-0 pb-0">
                    <div align="center"></div>
                    <div class="truncate">
                      <div class="font-header mt-4 text-danger" align="center">
                        <!-- {{
                          this.itemHeader.total_visit_fee_today
                            | numFormat(0, 0)
                        }} -->
                        <IOdometer
                          class="iOdometer"
                          :value="this.itemHeader.total_visit_fee_today"
                        />
                      </div>
                      <h2 class="text-danger" align="center">ค่าจอดรถวันนี้</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-card>

    <div class="vx-row" style="margin-top: 10px">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <vx-card style="width: 100%; height: 360px">
          <div class="vx-row justify-center items-center">
            <img
              class="mb-1"
              src="@/assets/images/k/siren.gif"
              style="width: 30px; height: 30px"
              v-if="this.itemHeader.is_alert === true"
            />
            <img
              class="mb-1"
              src="@/assets/images/k/siren.png"
              style="width: 30px; height: 30px"
              v-else
            />
            <h3 class="ml-4">รายงานปัญหาเครื่อง</h3>
          </div>
          <vx-card class="overflow-auto" style="width: 100%; height: 280px">
            <ol>
              <li :key="index" v-for="(trr, index) in itemIssue">
                <h5>
                  {{ itemIssue[index].customer_name }} -
                  <span
                    style="color: red"
                    v-if="itemIssue[index].issue_type === 1"
                    >{{ itemIssue[index].issue }}</span
                  >
                  <span
                    style="color: #40ada7"
                    v-else-if="itemIssue[index].issue_type === 2"
                    >{{ itemIssue[index].issue }}</span
                  >
                  <span
                    style="color: #aa8f00"
                    v-else-if="itemIssue[index].issue_type === 3"
                    >{{ itemIssue[index].issue }}</span
                  >
                  <span
                    style="color: #f9aa26"
                    v-else-if="itemIssue[index].issue_type === 4"
                    >{{ itemIssue[index].issue }}</span
                  >
                  <br />
                  <br />
                  <hr color="#E5E5E5" size="1" />
                </h5>
              </li>
            </ol>
          </vx-card>
          <div class="vx-row justify-center items-center">
            <span>loading...</span>
            <img
              class="mt-1 ml-4"
              src="@/assets/images/k/loading.gif"
              style="width: 20px; height: 20px"
            />
          </div>
        </vx-card>
        <vx-card
          class="mt-3"
          style="margin-top: 20px width: 100%; height: 356px"
        >
          <h3 align="center">รายการรถเข้าล่าสุด</h3>
          <vx-card class="overflow-auto" style="width: 100%; height: 286px">
            <ol>
              <li :key="index" v-for="(trr, index) in itemKVisit">
                <h5>
                  {{ itemKVisit[index].customer_name }} :
                  <span style="color: #3a62ee">{{
                    itemKVisit[index].license
                  }}</span>
                  <br />
                  <br />
                  <hr color="#E5E5E5" size="1" />
                </h5>
              </li>
            </ol>
          </vx-card>
          <div class="vx-row justify-center items-center">
            <span>loading...</span>
            <img
              class="mt-1 ml-4"
              src="@/assets/images/k/loading.gif"
              style="width: 20px; height: 20px"
            />
          </div>
        </vx-card>
        <vx-card class="overflow-hidden mt-3" style="width: 100%; height: 50px">
          <h2 align="center">Power by KODER3 @2023</h2>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-3/5 xl:w-3/5">
        <gmap-map
          ref="mapRef"
          :center="center"
          :zoom="12"
          style="width: 100%; height: 625px"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            disableDefaultUI: false,
          }"
        >
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="toggleInfoWindow(m, index)"
            :icon="getMarker(m)"
          ></gmap-marker>
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <div v-html="infoContent"></div>
          </gmap-info-window>
        </gmap-map>
        <div class="vx-row" style="margin-top: 10px">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3"
            :key="index"
            v-for="(trr, index) in itemProductType"
          >
            <vx-card class="overflow-hidden">
              <div class="vx-row">
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1">
                  <div
                    class="vx-card__collapsible-content vs-con-loading__container"
                  >
                    <div class="vx-row">
                      <div
                        class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1"
                      >
                        <div slot="no-body">
                          <div class="p-0 pb-0">
                            <div align="center"></div>
                            <div class="truncate">
                              <h1
                                style="color: #f9aa26"
                                align="center"
                                v-if="itemProductType[index].key === 'K-Visit'"
                              >
                                {{ itemProductType[index].key }}
                              </h1>
                              <h1
                                style="color: #0097fb"
                                align="center"
                                v-else-if="
                                  itemProductType[index].key === 'K-Park'
                                "
                              >
                                {{ itemProductType[index].key }}
                              </h1>
                              <h1
                                style="color: #cc8aff"
                                align="center"
                                v-else-if="
                                  itemProductType[index].key === 'K-Scan'
                                "
                              >
                                {{ itemProductType[index].key }}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row" style="margin-top: 10px">
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <div
                    class="vx-card__collapsible-content vs-con-loading__container"
                  >
                    <div slot="no-body">
                      <div class="p-0 pb-0">
                        <div align="center">
                          <div class="vx-row">
                            <div
                              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
                            >
                              <feather-icon
                                icon="WifiIcon"
                                class="p-3 inline-flex feather-icon select-none relative text-success mb-3"
                                svgClasses="h-10 w-10 ml-2 hover:text-primary cursor-pointer"
                              >
                              </feather-icon>
                            </div>
                            <div
                              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
                            >
                              <h1 class="mt-3 mr-4">
                                {{ itemProductType[index].online }}
                              </h1>
                            </div>
                          </div>
                        </div>
                        <div class="truncate">
                          <h4 align="center">Online / เครื่อง</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                  <div
                    class="vx-card__collapsible-content vs-con-loading__container"
                  >
                    <div slot="no-body">
                      <div class="p-0 pb-0">
                        <div class="vx-row">
                          <div
                            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
                          >
                            <feather-icon
                              icon="WifiOffIcon"
                              class="p-3 inline-flex feather-icon select-none relative text-danger mb-3"
                              svgClasses="h-10 w-10 ml-2 hover:text-primary cursor-pointer"
                            >
                            </feather-icon>
                          </div>
                          <div
                            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
                          >
                            <h1 class="mt-3 mr-4" align="center">
                              {{ itemProductType[index].offline }}
                            </h1>
                          </div>
                        </div>
                        <div class="truncate">
                          <h4 align="center" class="fs-6">Offline / เครื่อง</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vx-card style="width: 100%; height: 300px">
              <div class="vx-row">
                <div class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3">
                  <h3 class="" style="color: #886a00" align="center">
                    โครงการทั้งหมด
                  </h3>
                </div>
                <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
                  <h3 class="" style="color: #886a00" align="center">
                    {{ this.totalChart }}
                  </h3>
                </div>
              </div>
              <vue-apex-charts
                type="pie"
                width="350"
                class=""
                :options="statTotal"
                :series="statTotalList.series"
                align="center"
              />
            </vx-card>
          </div>
        </div>
        <vx-card
          class="mt-3"
          style="margin-top: 10px width: 100%; height: 415px"
        >
          <h3 align="center">รายการ รปภ เดินตรวจ</h3>
          <vx-card class="overflow-auto" style="width: 100%; height: 340px">
            <ol>
              <li :key="index" v-for="(trr, index) in itemKScan">
                <h5>
                  <div class="vx-row">
                    <div
                      class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3"
                    >
                      {{ itemKScan[index].customer_name }} <br />
                      <span
                        style="color: #008e0e"
                        v-if="itemKScan[index].wordStart === true"
                        >{{ itemKScan[index].round_name }}</span
                      >

                      <span style="color: #9747ff" v-else>{{
                        itemKScan[index].round_name
                      }}</span>
                    </div>
                    <div
                      class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3"
                    >
                      <span
                        >{{
                          itemKScan[index].create_date | formatTime
                        }}
                        น.</span
                      >
                    </div>
                  </div>
                  <br />
                  <hr color="#E5E5E5" size="1" />
                </h5>
              </li>
            </ol>
          </vx-card>
          <div class="vx-row justify-center items-center">
            <span>loading...</span>
            <img
              class="mt-1 ml-4"
              src="@/assets/images/k/loading.gif"
              style="width: 20px; height: 20px"
            />
          </div>
        </vx-card>
        <vx-card class="overflow-hidden mt-3" style="width: 100%; height: 50px">
          <h1 align="center">
            <span>{{ currentDate() }}</span
            >&nbsp;
            <span
              >{{ dateTime.hours }}:{{ dateTime.minutes }}:{{
                dateTime.seconds
              }}</span
            >
          </h1>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue, { ref } from "vue";
import VueCryptojs from "vue-cryptojs";
import VueCookies from "vue-cookies";
import { db } from "../store/firebaseDb";

const moment = require("moment");
require("moment/locale/th");
import Datepicker from "vuejs-datepicker";
import CustomerHeader from "@/layouts/components/custom/CustomerHeader.vue";
import vSelect from "vue-select";

import VueApexCharts from "vue-apexcharts";
import _color from "@/assets/utils/color.js";
import Paginate from "vuejs-paginate";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import json from "@/store/location.json";
import IOdometer from "vue-odometer";
import "odometer/themes/odometer-theme-default.css";

Vue.component("paginate", Paginate);

Vue.use(VueCryptojs);
Vue.use(VueCookies);
Vue.use(VueApexCharts);

Vue.component("customer-header", CustomerHeader);
Vue.component("vue-apex-charts", VueApexCharts);
Vue.component("v-select", vSelect);
Vue.filter("numFormat", numFormat(numeral));
Vue.filter("formatDate", function (value) {
  if (value) {
    const myDate = new Date(value.seconds * 1000); // date object
    return moment(String(myDate)).format("DD/MM/YYYY HH:mm:ss");
  }
  return "-";
});

Vue.filter("formatTime", function (value) {
  if (value) {
    const myDate = new Date(value.seconds * 1000); // date object
    return moment(String(myDate)).format("HH:mm");
  }
  return "-";
});

moment.locale("th");
Vue.use(require("vue-moment"), {
  moment,
});

console.log(Vue.moment().locale());

const date = new Date();
export default {
  name: "ManageMonitoring",
  components: {},
  data() {
    return {
      randomData: json,
      statTotal: {
        chart: {
          id: "apexchart-example",
        },
        title: {
          align: "center",
          style: {
            fontSize: "20px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        colors: ["#F9AA26", "#0097FB", "#CC8AFF"],
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          position: "bottom",
        },
        labels: [],
      },
      statTotalList: {},
      totalChart: "",
      markers: [],
      currentPlace: null,
      checkpointOrderList: [],
      roundInfoData: null,
      round_id: "",
      center: { lat: 13.753613991925093, lng: 100.58298568113348 },
      currentPlace: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      infoContent: "",
      items: [],
      lastItemsList: {},
      page: 1,
      itemHeader: [],
      itemIssue: [],
      itemKScan: [],
      itemKVisit: [],
      itemProductType: [],
      itemSku: [],

      dateTime: {
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
      },
      timer: undefined,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getMarker: function (item) {
      let iconName = require("../assets/images/pin/kvisit.svg");

      if (item.is_alert === true) {
        if (item.type.id === "K-Visit") {
          iconName = require("../assets/images/pin/alert_kvisit.gif");
        } else if (item.type.id === "K-Scan") {
          iconName = require("../assets/images/pin/alert_kscan.gif");
        } else {
          iconName = require("../assets/images/pin/alert_kpark.gif");
        }
      } else {
        if (item.type.id === "K-Visit") {
          iconName = require("../assets/images/pin/kvisit.png");
        } else if (item.type.id === "K-Scan") {
          iconName = require("../assets/images/pin/kscan.png");
        } else if (item.type.id === "K-Park") {
          iconName = require("../assets/images/pin/kpark.png");
        }
      }

      return {
        url: iconName,
        scaledSize: { width: 60, height: 60 },
      };
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getInfoWindowContent: function (marker) {
      return `<div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <h6 class="title is-4">${marker.customer_name}</h6>
            </div>
            <hr color="#E5E5E5" size="1" />
             <br />
          </div>
          <div class="content">
            <img
            src="data:image/png;base64,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"
            style="width: 20px; height: 20px"
            />  ${marker.tel_no}
            <br />
            <img
            src="data:image/png;base64,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"
            style="width: 20px; height: 20px"
            />  ${marker.issue}
            <br />
            <img
            src="data:image/png;base64,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"
            style="width: 20px; height: 20px"
            />  ${marker.sn}
          </div>
        </div>
      </div>`;
    },

    setPlace(place) {
      this.currentPlace = place;
    },

    dbRef() {
      const _ducumentPath = `dashboard`;
      return db.collection(_ducumentPath);
    },
    getDbRefWithCondition() {
      let reference = this.dbRef();
      return reference;
    },
    async listItems({ page = 1 }) {
      this.page = page;
      this.dbRef().onSnapshot((snapshotChange) => {
        this.itemHeader = [];
        snapshotChange.forEach(async (doc) => {
          this.lastItemsList[`${page}`] = doc;
          const data = doc.data();
          this.itemHeader = data;
        });
      });
    },

    dbRefIssue() {
      const _ducumentPath = `dashboard/data/issues`;
      return db
        .collection(_ducumentPath)
        .where("issue_type", "==", 3)
        .orderBy("create_date", "desc")
        .limit(50);
    },
    getDbRefWithConditionIssue() {
      let reference = this.dbRefIssue();
      reference = reference;

      return reference;
    },
    async listItemsIssue({ page = 1 }) {
      this.page = page;
      this.getDbRefWithConditionIssue().onSnapshot((snapshotChange) => {
        this.itemIssue = [];
        let items = [];
        snapshotChange.forEach(async (doc) => {
          this.lastItemsList[`${page}`] = doc;
          const data = doc.data();
          items[items.length] = {
            key: doc.id,
            create_date: data.create_date,
            customer_name: data.customer_name,
            issue: data.issue,
            issue_type: data.issue_type,
          };
          this.itemIssue = items;
        });
      });
    },

    dbRefKScanTrans() {
      const _ducumentPath = `dashboard/data/k-scan-trans`;
      return db
        .collection(_ducumentPath)
        .orderBy("create_date", "desc")
        .limit(50);
    },
    getDbRefWithConditionKScanTrans() {
      let reference = this.dbRefKScanTrans();
      reference = reference;

      return reference;
    },
    async listItemsKScanTrans({ page = 1 }) {
      this.page = page;
      this.getDbRefWithConditionKScanTrans().onSnapshot((snapshotChange) => {
        this.itemKScan = [];
        let items = [];
        snapshotChange.forEach(async (doc) => {
          this.lastItemsList[`${page}`] = doc;
          const data = doc.data();

          items[items.length] = {
            key: doc.id,
            create_date: data.create_date,
            customer_name: data.customer_name,
            round_name: data.round_name,
            wordStart: data.round_name.startsWith("เริ่มตรวจรอบ")
              ? true
              : false,
          };
          this.itemKScan = items;
        });
      });
    },

    dbRefKVisitTrans() {
      const _ducumentPath = `dashboard/data/k-visit-trans`;
      return db
        .collection(_ducumentPath)
        .orderBy("create_date", "desc")
        .limit(50);
    },
    getDbRefWithConditionKVisitTrans() {
      let reference = this.dbRefKVisitTrans();
      reference = reference;

      return reference;
    },
    async listItemsKVisitTrans({ page = 1 }) {
      this.page = page;
      this.getDbRefWithConditionKVisitTrans().onSnapshot((snapshotChange) => {
        this.itemKVisit = [];
        let items = [];
        snapshotChange.forEach(async (doc) => {
          this.lastItemsList[`${page}`] = doc;
          const data = doc.data();

          items[items.length] = {
            key: doc.id,
            create_date: data.create_date,
            customer_name: data.customer_name,
            license: data.license_plate_id,
          };
          this.itemKVisit = items;
        });
      });
    },

    dbRefProductType() {
      const _ducumentPath = `dashboard/data/product_type`;
      return db.collection(_ducumentPath);
    },
    getDbRefWithConditionProductType() {
      let reference = this.dbRefProductType();
      return reference;
    },
    async listItemsProductType({ page = 1 }) {
      this.page = page;
      this.getDbRefWithConditionProductType().onSnapshot((snapshotChange) => {
        this.itemProductType = [];
        let items = [];
        snapshotChange.forEach(async (doc) => {
          const data = doc.data();

          items[items.length] = {
            key: doc.id,
            offline: data.offline,
            online: data.online,
            percent: data.percent,
            total: data.total,
          };

          const include = [];
          this.itemProductType = include
            .concat(items[2])
            .concat(items[0])
            .concat(items[1]);
        });
        const seriesData = [];
        for (let i = 0; i < this.itemProductType.length; i++) {
          seriesData.push(this.itemProductType[i].total);
          this.statTotal.labels.push(this.itemProductType[i].key);

          const sum = seriesData.reduce((accumulator, value) => {
            return accumulator + value;
          }, 0);

          this.totalChart = sum;
        }
        this.statTotalList = {
          series: seriesData,
        };
      });
    },

    dbRefSku() {
      const _ducumentPath = `dashboard/data/sku`;
      return db
        .collection(_ducumentPath)
        .where("is_show_in_dashboard", "==", true);
    },
    getDbRefWithConditionSku() {
      let reference = this.dbRefSku();
      reference = reference;

      return reference;
    },
    async listItemsSku({ page = 1 }) {
      this.page = page;
      let fakePosiiton = {};

      this.getDbRefWithConditionSku().onSnapshot((snapshotChange) => {
        this.itemSku = [];
        let items = [];
        snapshotChange.forEach(async (doc) => {
          const data = doc.data();

          if (data.location.latitude === 0 && data.location.longitude === 0) {
            const randomNumber = Math.floor(Math.random() * 154) + 1;
            let loc = fakePosiiton[doc.id];
            if (loc == null) {
              loc = this.randomData[randomNumber];
              fakePosiiton[doc.id] = loc;
            }
            items[items.length] = {
              key: doc.id,
              position: {
                lat: loc.latitude,
                lng: loc.longitude,
              },

              create_date: data.create_date,
              customer_name: data.customer_name,
              is_alert: data.is_alert,
              issue: data.issue ? data.issue : "-",
              issue_type: data.issue_type,
              sn: data.sn,
              tel_no: data.tel_no ? data.tel_no : "-",
              type: data.type,
              update_date: data.update_date,
              is_show_in_dashboard: data.is_show_in_dashboard,
            };
          } else {
            items[items.length] = {
              key: doc.id,
              position: {
                lat: data.location.latitude,
                lng: data.location.longitude,
              },
              create_date: data.create_date,
              customer_name: data.customer_name,
              is_alert: data.is_alert,
              issue: data.issue ? data.issue : "-",
              issue_type: data.issue_type,
              sn: data.sn,
              tel_no: data.tel_no ? data.tel_no : "-",
              type: data.type,
              update_date: data.update_date,
              is_show_in_dashboard: data.is_show_in_dashboard,
            };
          }
          this.markers = items;
          this.$refs.mapRef.$mapPromise.then((map) => {
            const bounds = new google.maps.LatLngBounds();
            for (const m of this.markers) {
              map.panTo(m.position);
              bounds.extend(m.position);
            }
          });
        });
      });
    },

    setDateTime() {
      const date = new Date();
      this.dateTime = {
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
      };
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`;
      return date;
    },
    theFormat(number) {
      let nf = new Intl.NumberFormat("en-US");
      return nf.format(number.toFixed(0));
    },

    addCenterControl(controlDiv) {
      const controlUI = document.createElement("div");

      controlUI.innerHTML = `
         <img
            src="data:image/png;base64,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"
            style="width: 400px; height: 80px"
          />
      `;

      controlDiv.appendChild(controlUI);
    },
  },

  beforeMount() {
    this.timer = setInterval(this.setDateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      // Create the DIV to hold the control and call the CenterControl()
      // constructor passing in this DIV.
      const centerControlDiv = document.createElement("div");
      this.addCenterControl(centerControlDiv, map);
      map.controls[google.maps.ControlPosition.LEFT_TOP].push(centerControlDiv);
    });
  },
  components: {
    Datepicker,
    IOdometer,
  },
  async created() {
    this.listItems({ page: this.page });
    this.listItemsIssue({ page: this.page });
    this.listItemsKScanTrans({ page: this.page });
    this.listItemsKVisitTrans({ page: this.page });
    this.listItemsProductType({ page: this.page });
    this.listItemsSku({ page: this.page });
  },
};
</script>

<style>
.font-header {
  font-size: 55px;
}
.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.vs-input {
  width: 100%;
  margin-top: 10px;
}

.card-info {
  padding: 12px;
  margin-left: 10px;
  width: 100%;
  font-size: 18px;
}

.card-horizontal {
  display: flex;
  flex: 1 1 auto;
}

.fullscreen-v-img {
  z-index: 9999999999999 !important;
}

.img-ul ul li {
  position: relative;
  border: 2px solid rgb(143, 141, 141);
  display: inline-block;
  text-align: center;
  margin-left: 6px;
}

.img-ul ul {
  text-align: left;
}
</style>

<style scoped>
.order-col {
  width: 100px;
}

.name-col {
  width: 260px;
}

.status-col {
  width: 160px;
}

.map-list-table td {
  min-height: 100px !important;
}

.vue-map-container {
  border: solid 6px #f1eded;
}
.notNorlmalCase {
  background-color: #c3252a !important;
  color: #fff;
  min-width: 100px;
}

.norlmalCase {
  background-color: #009f22 !important;
  color: #fff;
  min-width: 150px;
}
.box {
  position: absolute;
  padding: 20px 50px 0px 30px;
  color: rgb(116, 124, 142);
  font-size: 15px;
}
</style>
